import React from 'react'
import getTranslationTime from '../functions/getTranslationTime'

const TranslationTime = ({id, trans, dateString, children}) => {
    return getTranslationTime(id, trans, dateString, children)
}

export default TranslationTime